var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import { theme, Flex } from "antd";
const LiveStatusBox = ({ minutes = 0, style = {} }) => {
  const { token } = theme.useToken();
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      align: "center",
      gap: 4,
      style: __spreadValues({
        fontWeight: 500,
        color: token.colorLiveRed,
        fontSize: token.fontSizeLG,
        fontFamily: token.secondaryFontFamily
      }, style),
      children: [
        /* @__PURE__ */ jsx("span", { children: minutes }),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "live-animation",
            style: { position: "relative", top: -3 },
            children: "'"
          }
        )
      ]
    }
  );
};
var stdin_default = LiveStatusBox;
export {
  stdin_default as default
};
